import { Box } from '@mui/material';

const formatStatus = (status: string) => (status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : '');

export const InlinePill = ({ status }: { status: string }) => {
    if (!status) return null;

    const styles =
        status.toUpperCase() === 'ACTIVE'
            ? { backgroundColor: '#CCF2F0', color: '#00BFB3' }
            : { backgroundColor: '#FFE0D2', color: '#FF6035' };

    return (
        <Box
            component="span"
            sx={{
                px: 1.5,
                py: 0.25,
                borderRadius: '7px',
                fontSize: '0.875rem',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...styles
            }}
        >
            {formatStatus(status)}
        </Box>
    );
};
